"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArchivePage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ArchivePage = props => {
  const {
    t,
    archiveList
  } = props;
  (0, _react.useEffect)(() => {
    document.title = t('Pages.Archive.Title');
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-flex__container"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "con-heading con-heading__l--margin-bottom-3"
  }, t('Pages.Archive.Header'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-archive-button__wrap"
  }, archiveList && archiveList.map(archive => {
    const url = '/archive/' + archive.year;
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      className: "con-archive__button",
      to: url
    }, archive.title);
  }))));
};
exports.ArchivePage = ArchivePage;
ArchivePage.propTypes = {
  t: _propTypes.default.func,
  archiveList: _propTypes.default.array
};